__turbopack_context__.v({
  "applePayButton": "ApplePayExpressButton-module__YsjY-G__applePayButton",
  "label": "ApplePayExpressButton-module__YsjY-G__label",
  "logo": "ApplePayExpressButton-module__YsjY-G__logo",
  "logoSlot": "ApplePayExpressButton-module__YsjY-G__logoSlot",
});
